module.exports = __webpack_public_path__ + "static/bg-slider1-ac23a00805aa1210823c7fb86698044c.jpg";